<template>
    <div class="detail-video" :class="ishidden?'hidden':''">
        <div ref="trylisten" class="detail-video__player">
            <div class="detail-video__player__title">
                <h3>{{title}}</h3>
                <i class="icon iconfont icon-guanbi" @click="onCloseVideoHandler"></i>
            </div>
            <video
                v-if="!ishidden"
                ref="video"
                controlslist="nodownload"
                oncontextmenu="return false"
                controls
                :src="videoUrl"
            >
            </video>
        </div>
    </div>
</template>
<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import {mapState} from 'vuex';
import api from '~/api';

export default {
    props: {
        title: {
            type: String,
            default() {
                return '';
            }
        },
        url: {
            type: String,
            default() {
                return '';
            }
        },
        expireTime: {
            type: Number,
            default() {
                return 0;
            }
        }
    },
    data() {
        return {
            ishidden: true,
            newUrl: ''
        };
    },
    computed: {
        ...mapState({
            courseId: state => state.courseId,
        }),
        videoUrl() {
            return this.newUrl || this.url;
        }
    },
    beforeCreate() {
        this.refreshTimeout = null;
        // 表示视频正在播放
        this.playing = false;
        this.retry = 0;
    },
    mounted() {
        this.autoRefresh(this.expireTime);
    },
    beforeDestroy() {
        this.resetTimer();
    },
    methods: {
        triggerPlayVideo() {
            this.ishidden = false;
            this.retry = 0;
            if (document.documentElement.clientHeight > 454) {
                this.$refs.trylisten.style.marginTop = `${(document.documentElement.clientHeight - 454) / 2}px`;
            }
            this.$nextTick(this.playVideo);
        },
        playVideo() {
            const {video} = this.$refs;
            if (video) {
                video.play()
                    .then(() => {
                        this.playing = true;
                    })
                    .catch(error => {
                        console.log(error);
                        this.refreshUrl();
                    });
            }
        },
        refreshUrl() {
            // 视频开始播放后不再自动更新视频链接
            if (this.playing) {
                return;
            }
            this.$axios.$get(api.course.tryListenUrl, {
                params: {
                    courseId: this.courseId
                }
            }).then(res => {
                const {data: {expireTime, videoUrl} = {}} = res;
                this.newUrl = videoUrl;
                if (videoUrl) {
                    if (++this.retry < 3) {
                        this.autoRefresh(expireTime);
                    }
                    else {
                        this.resetTimer();
                    }
                }
                // 用户已经点开了视频,自动播放
                if (!this.ishidden) {
                    if (videoUrl && this.retry < 3) {
                        this.$nextTick(this.playVideo);
                    }
                    else {
                        this.$toasted.show('请稍后重试', {
                            theme: 'toasted-primary',
                            position: 'top-center',
                            duration: 2000
                        });
                        this.ishidden = true;
                    }
                }
            });
        },
        autoRefresh(expireTime) {
            this.resetTimer();
            expireTime = +expireTime;
            if (isNaN(expireTime) || expireTime < 0) {
                return;
            }
            this.refreshTimeout = setTimeout(this.refreshUrl, expireTime);
        },
        resetTimer() {
            if (this.refreshTimeout) {
                clearTimeout(this.refreshTimeout);
                this.refreshTimeout = null;
            }
        },
        onCloseVideoHandler() {
            this.ishidden = true;
        }
    }
};
</script>
<style lang="less">
.detail-video {
    background: #0006;
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 399;

    &__player {
        margin: 0 auto;
        margin-top: 0;
        padding-top: 7px;
        padding-bottom: 17px;
        width: 720px;
        // height:454px;
        background: #fff;
        border-radius: 4px;
        text-align: center;

        &__title {
            position: relative;
            color: #32404b;
            text-align: center;
            padding-bottom: 8px;
            border-bottom: 1px solid #f5f5f5;

            h3 {
                margin: 0;
                font-size: 18px;
                line-height: 25px;
                vertical-align: top;
            }

            .icon-guanbi {
                position: absolute;
                top: 2px;
                right: 9px;
                font-size: 12px;
                line-height: 12px;
                color: #bfbfbf;
                font-weight: 400;
                display: block;
                cursor: pointer;
            }
        }

        video {
            width: 682px;
            height: 383px;
            margin: 0 auto;
            margin-top: 13px;
        }
    }

    &__player.compute {
        margin-top: 59px;
    }
}

.detail-video.hidden {
    display: none;
}
</style>
